import { Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../../components/Comman/Button";
import DynamicFormWithoutValidation from "../../../components/dynamicscreens/DynamicFormWithoutValidation";
import dayjs from "dayjs";
import { SalesTeamLeaveJson } from "../../../DynamicFormsJson/MastersJSON/salesTeamLeaveJson";
import { getLeaveBalanceInfoOfSalesTeam } from "../../../Slice/LeaveType.slice";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import RTTable from "../../../components/Comman/RT/RTTable";
import DynamicDetails from "../../../components/dynamicscreens/DynamicDetails";
import { withRouter } from "../../../components/withRouter";
import { mandatoryCheck, ValidationCheck } from "../../../config/ValidationCheck";
import endpoint from "../../../config/endpoints";
import {
    areYouSureMsg,
    leaveAlreadyAppliedMsg,
    noInternetMsg,
    saveFailedMsg,
    savemsg,
    saveWarningMsg,
    serverMsg,
    toDateCannotBeLessThanFromDateMsg,
} from "../../../config/messageconstant";
import { apiGet, apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class AddSalesTeamLeaveForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formErrors: {},
            DataToSet: [],
            detailsObj: {},
            fieldData: { leaveFor: "0", noOfDays: "0" },
            dynamicMasterData: {
            },
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.leaveList !== nextProps.leaveList) {
            if (
                this.props.leaveList?.leaveBalanceBySalesTeam !==
                nextProps.leaveList?.leaveBalanceBySalesTeam
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        leaveTypeDetail: nextProps.leaveList?.leaveBalanceInfo?.leaveBalanceList.filter((row) => row.balanceLeave > 0),
                    },
                });
            }
        }
    }

    async componentDidMount() {
        const {
            getLeaveBalanceInfoOfSalesTeam,
            showLoador,
            showNotification,
        } = this.props;

        if (navigator.onLine) {

            const salesTeamId = localStorage.getItem("salesTeamIdForAddLeave");

            showLoador({ loador: true });
            await getLeaveBalanceInfoOfSalesTeam({ salesTeamId: salesTeamId }).then(({ response, success }) => {
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                } else {
                    this.setState({
                        dynamicMasterData: {
                            leaveTypeDetail: response?.leaveBalanceList?.filter((row) => row.balanceLeave > 0) || [],
                        },
                        DataToSet: [
                            {
                                xs: 12,
                                sm: 4,
                                md: 4,
                                lg: 4,
                                label: "Emp Code",
                                value: response.employeeCode !== null ? response.employeeCode : "",
                            },
                            {
                                xs: 12,
                                sm: 4,
                                md: 4,
                                lg: 4,
                                label: "Sales Team",
                                value: response.salesTeamName !== null ? response.salesTeamName : "",
                            },
                            {
                                xs: 12,
                                sm: 4,
                                md: 4,
                                lg: 4,
                                label: "Reporting Authority",
                                value: response.authoritySalesPersonName !== null ? response.authoritySalesPersonName : "",
                            },
                        ],
                        detailsObj: response,
                    })
                }
            });
            showLoador({ loador: false });

        } else {
            showNotification({
                msg: noInternetMsg,
                severity: "error",
            });
        }
    }

    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;

        if (dayjs(fieldData.toDate).isBefore(dayjs(fieldData.fromDate))) {
            this.props.showNotification({
                msg: toDateCannotBeLessThanFromDateMsg,
                severity: "error",
            });
            return;
        }

        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: SalesTeamLeaveJson.fieldMetaForAddSalesTeamLeave,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        if (mandatoryCheckErrors.formValid) {
            const ValidationCheckErrors = ValidationCheck({
                fieldData,
                fieldMeta: SalesTeamLeaveJson.fieldMetaForAddSalesTeamLeave,
            });
            this.setState({
                formErrors: ValidationCheckErrors.formErrors,
            });
            return ValidationCheckErrors.formValid;
        } else {
            return false;
        }
    };

    onDataChange = (fieldName, newValue) => {
        const { fieldData } = this.state;

        let noOfDaysInteger = fieldData.noOfDays || "0";
        const dataToReset = { ...this.state.fieldData };
        SalesTeamLeaveJson.fieldMetaForAddSalesTeamLeave.map((currentField) => {

            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            return null;
        });

        dataToReset[fieldName] = newValue;

        if (fieldName == "fromDate" || fieldName == "toDate" || fieldName == "leaveFor") {

            const from = fieldName == "fromDate" ? dayjs(newValue) : dayjs(dataToReset.fromDate);
            const to = fieldName == "toDate" ? dayjs(newValue) : dayjs(dataToReset.toDate);

            const daysDifference = to.diff(from, "day") + 1;

            const leaveForValue = fieldName == "leaveFor" ? newValue : dataToReset.leaveFor;

            noOfDaysInteger = leaveForValue == 0 ? daysDifference : daysDifference * 0.5;
        }

        this.setState({
            fieldData: { ...dataToReset, noOfDays: noOfDaysInteger }
        });
    };


    onSave = async (dataToSave) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });
            await apiPost({
                url: endpoint.leaveApply,
                postBody: dataToSave,
            }).then(({ data, success }) => {
                if (success) {
                    showNotification({ msg: savemsg });
                    this.props.navigate(-1);
                } else {
                    showNotification({ msg: saveFailedMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    onSubmitData = async () => {
        const { showLoador, showNotification } = this.props;
        const { fieldData, detailsObj } = this.state;

        if (this.checkValidationOnSubmit()) {
            const fromDateWithFormat = dayjs(fieldData.fromDate).format("DD-MM-YYYY");
            const toDateWithFormat = dayjs(fieldData.toDate).format("DD-MM-YYYY");

            const from = dayjs(fieldData.fromDate);
            const to = dayjs(fieldData.toDate);

            const daysDifference = to.diff(from, "day") + 1;

            let dataToSave = {
                salesTeam: {
                    id: detailsObj.id,
                },
                leaveType: {
                    id: fieldData.leaveType,
                },
                authoritySalesPersonId: detailsObj.authoritySalesPersonId,
                authoritySalesPersonTypeId: detailsObj.authoritySalesPersonUserTypeId,
                fromDate: fromDateWithFormat,
                toDate: toDateWithFormat,
                leaveReason: fieldData.subject,
                description: fieldData.description,
                noOfDays:
                    fieldData.leaveFor == 0 ? daysDifference : daysDifference * 0.5,
                status: 2,
                isActive: 1,
                leaveCancelRemark: null,
                attachFile: null,
            };

            swal({
                title: areYouSureMsg,
                text: saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiGet({
                        url:
                            endpoint.leaveApply +
                            "/check-applicable-or-not?salesTeamId=" +
                            detailsObj.id +
                            "&fromDate=" +
                            fromDateWithFormat +
                            "&toDate=" +
                            toDateWithFormat,
                    }).then(({ data, success }) => {
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        } else {
                            if (data && data.data && data.data.statusCode == 500) {
                                showNotification({
                                    msg: leaveAlreadyAppliedMsg,
                                    severity: "error",
                                });
                            } else {
                                this.onSave(dataToSave);
                            }
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        }
    };

    onCancel = () => {
        this.props.navigate(-1);
    }

    render() {
        const {
            dynamicMasterData,
            formErrors,
            fieldData,
            DataToSet,
            detailsObj,
        } = this.state;

        const columns = [
            { title: "Sr.No.", name: "index", align: "center" },
            { title: "Leave Types", name: "leaveTypeName", align: "left" },
            { title: "Opening Leave Balance", name: "openingLeave", align: "right" },
            { title: "Earned Leave", name: "earnedLeave", align: "right" },
            { title: "Approved Leave", name: "approvedLeave", align: "right" },
            { title: "Applied Leave", name: "appliedLeave", align: "right" },
            { title: "Encash Leave", name: "encashLeave", align: "right" },
            { title: "Balance Leave", name: "balanceLeave", align: "right" },
        ];
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >
                    <LandingScreenHeader
                        screenTitle={SalesTeamLeaveJson.screenTitleForAddSalesTeamLeave}
                        showBackButton={true}
                        onCancel={this.onCancel}
                        showAddButton={false}
                    />
                    <br />
                    <DynamicDetails DataToSet={DataToSet} />

                    <RTTable
                        columns={columns}
                        tableData={detailsObj?.leaveBalanceList}
                        isActionColActive={false}
                        showPegination={false}
                    />
                    <br />
                    <DynamicFormWithoutValidation
                        dynamicMasterData={dynamicMasterData}
                        screenTitle={""}
                        fieldMeta={SalesTeamLeaveJson.fieldMetaForAddSalesTeamLeave}
                        apiBaseURL={SalesTeamLeaveJson.apiBaseURL}
                        formErrors={formErrors}
                        showSaveBtn={SalesTeamLeaveJson.showSaveBtn}
                        showSaveBtnMain={false}
                        getByIdApi={true}
                        callApi={true}
                        fieldData={fieldData}
                        onDataChange={this.onDataChange}
                        showBackToList={false}
                    />
                    <br />
                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="right"
                    >
                        <ButtonCompo
                            size="medium"
                            type="button"
                            variant="contained"
                            name="Apply For Leave"
                            onClick={this.onSubmitData}
                        />
                    </Grid>
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    leaveList: state.leaveType,
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
    getLeaveBalanceInfoOfSalesTeam,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(AddSalesTeamLeaveForm);
